import React, { useEffect, useRef, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { Card, GrayCardTitle } from "../../common_components/Layout";
import { PrimaryButton, SecondaryButton } from "../../common_components/Buttons";

// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";

function CompletedSessionDetailsCard(props) {
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId, sessionId } = useParams()
    // const [recordings, setRecordings] = useState([]);
    // const [loading, setLoading] = useState(false);

    const mock_recordings =
        [{ url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf", name: "Recording 1", recording_type: "Active Speaker" },
        { url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf", name: "Recording 2", recording_type: "All Speakers" },
        { url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf", name: "Recording 3", recording_type: "Screen Share" },
        { url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf", name: "Recording 4", recording_type: "Transcript" }]

    // useEffect(() => {
    //     async function getEventRecordings() {
    //         console.log("Trying to donwload recordings")
    //         const result = await ScheduledEventAPI.one_mission_show_event_recordings({ missionId, sessionId, handleRedirect: navigate });

    //         if (result.success) {
    //             setRecordings(result.recordings)
    //             setLoading(false);
    //         } else {
    //             alert.show(result.error, { type: 'error' })
    //         }
    //     }

    //     getEventRecordings();
    // }, []);

    return (
        <Card>
            {props.loadingRecordings ? <CenteredLoadingIcon /> :
                <>
                    <VideoWithTranscript videoUrl={props.streamingUrl} transcript={props.transcript} />
                    {props.recordings && props.recordings.length > 0 &&
                        <div className="download-links-container">
                            <div className="download-links-title">Download Links</div>
                            {props.recordings.map((recording, index) => {
                                if (["mp4", "m4a", "vtt"].includes(recording.file_type)) {
                                    return (
                                        <RecordingDownloadButton key={index} recording={recording} />
                                    )
                                }
                            })}

                        </div>
                    }
                </>
            }
        </Card>
    )
}

function VideoWithTranscript({ videoUrl, transcript }) {
    const [formattedTranscript, setFormattedTranscript] = useState([]);
    const videoRef = useRef(null);


    useEffect(() => {
        setFormattedTranscript(parseVTT(transcript));
    }, [transcript]);

    // Function to seek video to a specific timestamp
    const seekToTime = (timecode) => {
        if (videoRef.current) {
            const seconds = timecodeToSeconds(timecode);
            videoRef.current.currentTime = seconds;
            videoRef.current.play();
        }
    };

    // Function to format timecode
    const formatTimecode = (timecode) => {
        const parts = timecode.split(":");
        let hours = String(parts[0]).padStart(2, "0");
        let minutes = String(parts[1]).padStart(2, "0");
        let seconds = String(Math.floor(parseFloat(parts[2]))).padStart(2, "0"); // Remove fractional seconds

        return `${hours}:${minutes}:${seconds}`;
    };

    // Function to convert timecode to seconds
    const timecodeToSeconds = (timecode) => {
        const parts = timecode.split(":");
        const hours = parseInt(parts[0], 10) || 0;
        const minutes = parseInt(parts[1], 10) || 0;
        const seconds = Math.floor(parseFloat(parts[2])) || 0;
        return hours * 3600 + minutes * 60 + seconds;
    };

    // Parse VTT file format into an array of objects
    function parseVTT(vttText) {
        if (vttText === undefined || vttText === null || vttText.length === 0) return [];
        const remove_file_format_text = vttText.replace(/^WEBVTT\r\n\r\n/, "");

        return remove_file_format_text
            .split(/\r?\n\r?\n/) // Split into caption blocks
            .map((block) => {
                const lines = block.split(/\r?\n/).map(line => line.trim()).filter(line => line !== ""); // Clean up lines

                if (lines.length < 3) return null; // Each block should have at least an index, timestamp, and text

                const timecode = lines[1].trim(); // Second line contains the timestamp
                const fullText = lines.slice(2).join(" "); // Join remaining lines as text

                // Extract speaker name if present
                const speakerMatch = fullText.match(/^(\w+):/);
                const name = speakerMatch ? speakerMatch[1] : null;
                const text = name ? fullText.replace(`${name}:`, "").trim() : fullText;

                return { timecode, name, text };
            })
            .filter((entry) => entry !== null);
    };

    return (

        <div className="video-and-transcript-container">
            {!videoUrl && !transcript && (
                <div className="video-and-transcript-container-empty">
                    <div className="video-and-transcript-container-empty-text">No video or transcript available yet. Please check back later.</div>
                </div>
            )}
            {videoUrl && (
                <div className="video-container">
                    <video ref={videoRef} className="video-player" controls width="640" height="360">
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            )}
            {transcript && (
                <div className="transcript-container">
                    <div className="transcript-box">
                        <div className="transcript-header-container">Transcript</div>
                        {formattedTranscript.length > 0 ? (
                            formattedTranscript.map((entry, index) => (
                                <p key={index}>
                                    <span className="timestamp" onClick={() => seekToTime(entry.timecode)}>
                                        {formatTimecode(entry.timecode)}
                                    </span>
                                    {entry.name && <span className="transcript-name-text">{entry.name}:</span>} {<span className="transcript-text">{entry.text}</span>}
                                </p>
                            ))
                        ) : (
                            <p>Loading transcript...</p>
                        )}
                    </div>
                    <div className="transcript-fade"></div>
                </div>
            )}
        </div>
    )
}
function RecordingDownloadLink(props) {
    return (
        <div className="recording-download-link-row">
            <div className="recording-download-link-title">{props.recording.name}</div>
            <a href={props.recording.presigned_url} className="link-no-underline" rel="noreferrer" download>
                <PrimaryButton text={"Download ." + props.recording.file_type} />
            </a>
        </div>
    )
}

function RecordingDownloadButton(props) {
    return (
        <a href={props.recording.presigned_url} className="link-no-underline" rel="noreferrer" download>
            <SecondaryButton style={{ whiteSpace: "nowrap" }} text={props.recording.name + " ." + props.recording.file_type} />
        </a>
    )
}





export default CompletedSessionDetailsCard;